export default __webpack_public_path__ + "static/ak-cached/24h/media/epix.687e1849.png";